// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Rana backend API
 * The API service for Rana.
 *
 * The version of the OpenAPI document: v1-alpha
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues, parseDate, parseDateTime, serializeDate, serializeDateTime } from "../runtime";
/**
 *
 * @export
 * @interface ResourceDate
 */
export interface ResourceDate {
  /**
   *
   */
  type: string | null;
  /**
   *
   */
  date: Date;
}

/**
 * Check if a given object implements the ResourceDate interface.
 */
export function instanceOfResourceDate(value: object): value is ResourceDate {
  if (!("type" in value) || value["type"] === undefined) return false;
  if (!("date" in value) || value["date"] === undefined) return false;
  return true;
}

export function ResourceDateFromJSON(json: any): ResourceDate {
  return ResourceDateFromJSONTyped(json, false);
}

export function ResourceDateFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResourceDate {
  if (json == null) {
    return json;
  }
  return {
    type: json["type"],
    date: json["date"] == null ? json["date"] : parseDateTime(json["date"]),
  };
}

export function ResourceDateToJSON(json: any): ResourceDate {
  return ResourceDateToJSONTyped(json, false);
}

export function ResourceDateToJSONTyped(
  value?: ResourceDate | null,
  ignoreDiscriminator: boolean = false
): any {
  if (value == null) {
    return value;
  }

  return {
    type: value["type"],
    date: value["date"] == null ? value["date"] : serializeDateTime(value["date"]),
  };
}
